import { useEffect, useMemo } from 'react';
import _ from 'lodash';
import useEntities from 'new/state/entities/repository/useEntities';
import usePaging from 'new/state/paging/repository/usePaging';
import { sortByDisplayOrder } from 'new/utils/displayOrder';

export default function useRerankerEndpoint(selectedConnection) {
  const { getSinkConfigFields } = usePaging();
  const { data: vendorEndpoints } = useEntities('vendorEndpoints');
  const fields = useMemo(
    () => getSinkConfigFields(selectedConnection, 'reranker'),
    [selectedConnection, vendorEndpoints],
  );

  return useMemo(() => {
    const endpointField = _.find(fields, { name: 'vendor_endpoint_id' });

    const filteredFields = fields.filter((field) => field.name !== 'vendor_endpoint_id');

    const endpoints: any[] = sortByDisplayOrder(
      Object.values(vendorEndpoints).filter((endpoint: any) => {
        if (!endpointField) return false;
        return (
          endpointField?.options.find((v) => v.value === endpoint.id) &&
          endpoint?.config?.supportedFlows?.sink?.includes('reranker')
        );
      }) as any[],
    );
    return {
      endpoint: endpoints[0],
      filteredFields,
    };
  }, [fields]);
}
